export default __webpack_public_path__ + "static/media/string.6cb9cef3.PNG";